<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <div
      v-if="showWarningPopup"
      ref="popup"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      class="rfp-rr-write-review-warning-240-or review-popup full-review-active selectPage-in-drop-down"
      data-popup="review-popup"
      style="display: block"
    >
      <div
        role="button"
        :aria-label="modalCloseButtonAccessibleLabel"
        tabindex="0"
        class="rfp-rr-write-review-warning-241-or review-popup-close"
        @keydown.space.prevent
        @keyup.space="closePopup"
        @keydown.enter="closePopup"
        @click="closePopup"
      >
        {{ popupClose }}
      </div>
      <div id="success-message" class="rfp-rr-write-review-warning-242-or popup-inner">
        <div
          class="rfp-rr-write-review-warning-243-or message-icon success"
          :class="{ 'image--display': warningIcon === '' }"
        >
          <img :src="warningIcon" :style="{ width: '100%' }" :alt="warningIconAltText" />
        </div>
        <div class="rfp-rr-write-review-warning-244-or message" v-html="warningText"></div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { trapFocus } from '../../../../../shared/utils/dom/focus';

export default {
  name: 'rfp-ratings-write-review-warning',
  props: {
    warningIcon: {
      type: String,
      required: true,
    },
    warningText: {
      type: String,
      required: true,
    },
    warningIconAltText: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: 'Close',
    },
  },
  data() {
    return {
      showWarningPopup: false,
      activeSlider: false,
      deactivateFocusTrap: null,
    };
  },
  watch: {
    async showWarningPopup(newVal) {
      if (newVal) {
        await this.$nextTick();
        this.deactivateFocusTrap = trapFocus(this.$refs.popup);
      } else {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
      }
    },
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('show-review-warning', () => {
      eventBus.emit('ScrollFalse');
      document.body.classList.add('rare-custom-body-class');
      this.activeSlider = true;
      this.showWarningPopup = true;
    });
  },
  mounted() {
    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (this.showWarningPopup && event.key === 'Escape') {
        this.closePopup();
      }
    },
    closePopup() {
      this.activeSlider = false;
      this.showWarningPopup = false;
      document.body.classList.remove('rare-custom-body-class');
      eventBus.emit('ScrollTrue');
    },
  },
};
</script>
